export default "__VITE_ASSET__CCKQB8Y$__"